import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme, styled, alpha } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";

import Close from "mdi-material-ui/Close";
import Magnify from "mdi-material-ui/Magnify";
import { debounce } from "lodash";
import { useCallback, useState } from "react";

const CustomSelectItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: "transparent !important",
  "&:hover": {
    backgroundColor: `${alpha(theme.palette.primary.main, 0.1)} !important`,
  },
}));

const QuickSearchToolbar = (props) => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const theme = useTheme();

  const {
    handleOpen,
    value,
    onChange,
    onClickDelete,
    clearSearch,
    selectedRows,
    title,
    isSearch,
    multiDelete,
    libraryCateList,
    onChangeCategory,
    categoryValue,
    isFilter,
    removeFilter,
    filter,
  } = props;
  const [searchText, setSearchText] = useState(value);

  const debouncedOnChange = useCallback(debounce(onChange, 900), []);

  return (
    <Box
      sx={{
        p: 2,
        pb: 2,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        m: (theme) => theme.spacing(1, 0.5, 1.5),
      }}
    >
      <Box>
        {multiDelete && (
          <Button
            type="submit"
            variant="outlined"
            disabled={selectedRows && selectedRows.length === 0}
            size={"medium"}
            onClick={onClickDelete}
            sx={{ mb: smallScreen ? 4 : 0 }}
          >
            Delete
          </Button>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          flexDirection: "row",
          width: smallScreen ? "100%" : "auto",
          justifyContent: smallScreen ? "space-between" : "flex-end",
        }}
      >
        {filter && libraryCateList.length > 0 && (
          <Box
            sx={{
              right: 12,
              top: smallScreen ? 10 : 0,
              position: smallScreen ? "absolute" : "relative",
            }}
          >
            <FormControl>
              <Select
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                size="small"
                value={categoryValue}
                onChange={onChangeCategory}
                sx={{
                  width: "200px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                labelId="validation-basic-select"
                aria-describedby="validation-basic-select"
              >
                <MenuItem value="" disabled>
                  Category
                </MenuItem>
                {libraryCateList !== undefined &&
                  libraryCateList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.cat_name}
                    </MenuItem>
                  ))}
                <CustomSelectItem value={isFilter ? "" : "Cat"}>
                  <Button
                    fullWidth
                    size="small"
                    color="primary"
                    onClick={() => {
                      setTimeout(() => {
                        removeFilter();
                      }, 200);
                    }}
                    sx={{ "&:hover": { backgroundColor: "transparent" } }}
                  >
                    Cancel
                  </Button>
                </CustomSelectItem>
              </Select>
            </FormControl>
          </Box>
        )}

        {isSearch && (
          <TextField
            variant="standard"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              debouncedOnChange(e);
            }}
            placeholder="Search…"
            InputProps={{
              startAdornment: <Magnify fontSize="small" />,
              endAdornment: (
                <IconButton
                  size="small"
                  title="Clear"
                  aria-label="Clear"
                  onClick={() => {
                    setSearchText("");
                    clearSearch();
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            }}
            sx={{
              width: {
                sm: "auto",
              },
              "& .MuiSvgIcon-root": {
                mr: 0.5,
              },
              "& .MuiInput-underline:before": {
                borderBottom: 1,
                borderColor: "divider",
              },
              "& .MuiInput-underline:after": {
                borderBottom: 2,
                borderColor: theme.palette.primary.main,
              },
              mr: 3,
              mb: smallScreen ? 2 : 0,
            }}
          />
        )}

        {!!title && (
          <Button
            type="submit"
            variant="contained"
            size={"medium"}
            onClick={handleOpen}
            sx={{ mb: smallScreen ? 2 : 0 }}
          >
            {title}
          </Button>
        )}
      </Box>
    </Box>
  );
};

QuickSearchToolbar.defaultProps = {
  isSearch: true,
  multiDelete: true,
  filter: false,
};

export default QuickSearchToolbar;
